import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useFormik } from "formik";
import toast from "react-hot-toast";

import "./createClient.css";

import {
  createUserFormValidate,
  editUserFormValidate,
} from "../../../../helper/validate";
import * as api from "helper/helper";
import invalidClass from "../../helperFunctions/helpers";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
import LoadingButton from "../LoadingButton/LoadingButton";
import { onlyNumbersFloat, Singleton } from "helper/tools";
import { ConciliacionItemType } from "helper/const";
import { CurrencyInput } from "components/CurrencyInput";
import CreatePagoTable from "./CreateAbono/CreatePagoTable";

export const PagoModalMode = Object.freeze({
  Producto: "PRODUCTO",
  Cliente: "CLIENTE",
  Asociado: "ASOCIADO",
});

//
const OptionAbonar = {
  AdeudoQuincenal: 0,
  MismaCantidadCadaProducto: 1,
  DiferenteCantidadCadaProducto: 2,
};

/// renders
const CreatePago = forwardRef(
  (
    {
      reloadCobranza,
      cobranzaItem,
      productoParcialidad,
      asociadoId,
      cobranzaInfoDetail,
      interestItem,
      pagoModalMode = PagoModalMode.Producto,
    },
    ref,
  ) => {
    const modalRef = useRef();
    const buttonCancelModalRef = useRef();

    const [isActiveDisabled, setIsActiveDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [parcialidadActual, setParcialidadActual] = useState(null);

    const [allItems, setAllItems] = useState(null);
    const [adeudoQuincenal, setAdeudoQuincenal] = useState(0);
    const [usedAmount, setUsedAmount] = useState(0);

    const [totalAplicar, setTotalAplicar] = useState(0);
    const [invalidEntrante, setInvalidEntrante] = useState(false);

    const [canSave, setCanSave] = useState(false);

    const [canAdeudoQuincenal, setCanAdeudoQuincenal] = useState(false);

    const [errorOtroAmount, setErrorOtroAmount] = useState("");

    const [errorProductosAmount, setErrorProductosAmount] = useState([]);
    const [initialValues, setInitialValues] = useState({
      entrante: 0,
      productosAbonos: [],
    });

    const [optionAbonarChecked, setOptionAbonarChecked] = useState(
      OptionAbonar.AdeudoQuincenal,
    );

    //const [otroChecked, setOtroChecked] = useState(false);
    //    const [adeudoQuincenalChecked, setAdeudoQuincenalChecked] = useState(false);

    const [permissions, setPermissions] = useState({
      canCreate: false,
      canEdit: false,
      canVerDetalle: true,
    });

    const isSaveDisable = useRef();
    const fieldsSetup = useRef({});

    const createMode = true; //item == null || (item && Object.keys(item).length === 0);

    useEffect(() => {
      console.log("---> change item: CREATEPAGO ");

      if (pagoModalMode === PagoModalMode.Producto) {
        if (
          cobranzaItem == null ||
          (productoParcialidad == null && interestItem == null)
        ) {
          return;
        }

        let isActiveDisable = true;
        if (!createMode) {
          isActiveDisable = false;
        }
        setIsActiveDisabled(isActiveDisable);

        formik?.resetForm();

        setupFields();

        isSaveDisable.current =
          (createMode && !permissions.canCreate) ||
          (!createMode && !permissions.canEdit);

        //
        if (productoParcialidad) {
          let currentParcialidad = productoParcialidad?.parcialidades.find(
            (e) =>
              e.parcialidadNumero === productoParcialidad?.parcialidadNumero,
          );

          let abono = currentParcialidad.total;
          abono = Singleton.getInstance().format(abono);

          let pagado = Singleton.getInstance().format(
            productoParcialidad.totalPagado,
          );

          let debe = Singleton.getInstance().format(
            productoParcialidad.totalPendiente,
          );
          /*
           */

          /*let kurrent = Singleton.getInstance().format(
        currentParcialidad?.totalPagado ?? 0,
      );*/

          /*let adeudoQuincenal = Singleton.getInstance().format(
        productoParcialidad?.subPagoProductoAdicional?.total ?? 0,
      );*/
          //interestItem

          const newParcialidadActual = productoParcialidad.parcialidades.find(
            (e) =>
              e.parcialidadNumero === productoParcialidad.parcialidadNumero,
          );

          setParcialidadActual(newParcialidadActual);

          // preselectst
          const enableAdeudoQuincenal =
            cobranzaInfoDetail?.disponible >
            newParcialidadActual?.totalPendiente;
          setCanAdeudoQuincenal(!enableAdeudoQuincenal);

          //setAdeudoQuincenalChecked(enableAdeudoQuincenal);
          //setOtroChecked(!enableAdeudoQuincenal);
          setOptionAbonarChecked(OptionAbonar.AdeudoQuincenal);

          setAdeudoQuincenal(parcialidadActual?.totalPendiente ?? 0);
        } else if (interestItem) {
          setParcialidadActual(null);

          // preselectst
          const enableAdeudoQuincenal =
            cobranzaInfoDetail?.disponible > interestItem?.totalPendiente;
          setCanAdeudoQuincenal(!enableAdeudoQuincenal);
          //setAdeudoQuincenalChecked(enableAdeudoQuincenal);
          //setOtroChecked(!enableAdeudoQuincenal);

          setOptionAbonarChecked(OptionAbonar.MismaCantidadCadaProducto);

          setAdeudoQuincenal(interestItem?.totalPendiente ?? 0);
        }
      } else if (pagoModalMode === PagoModalMode.Cliente) {
        //
        let accumulator = 0;
        let countItems = 0;
        let newAllItems = [];
        //  let saldoAlCorte = 0;
        //    let totalAPagar = 0;

        let contentCount = 0;
        if (cobranzaItem.type === ConciliacionItemType.COBRANZA) {
          cobranzaItem.ordenParcialidades.forEach((ordenParcialidad) => {
            //
            ordenParcialidad.productoParcialidades.forEach(
              (productoParcialidad) => {
                const parcialidadActual =
                  productoParcialidad.parcialidades.find(
                    (e) =>
                      e.parcialidadNumero ===
                      productoParcialidad.parcialidadNumero,
                  );
                if (parcialidadActual) {
                  accumulator += parcialidadActual.totalPendiente;
                  countItems += 1;

                  newAllItems.push({
                    parcialidadActual,
                    producto: productoParcialidad.ordenVentaDetalle.producto,
                    productoParcialidad: productoParcialidad,
                    type: "producto",
                    productoAbono: 0,
                    eid: Math.floor(Math.random() * 10000),
                  });
                }
              },
            );
            //
          });
        } else if (cobranzaItem.type === ConciliacionItemType.INTERES) {
          newAllItems.push(...cobranzaItem.other);

          countItems += cobranzaItem.other.length;
          accumulator += cobranzaItem.other.reduce(
            (accumulator, interestItem) => {
              return accumulator + interestItem.totalPendiente;
            },
            0,
          );
        }

        console.log("---");

        setAllItems(newAllItems);

        setAdeudoQuincenal(accumulator);

        const enableAdeudoQuincenal =
          cobranzaInfoDetail?.disponible > accumulator;
        setCanAdeudoQuincenal(!enableAdeudoQuincenal);

        setOptionAbonarChecked(OptionAbonar.AdeudoQuincenal);
        //setAdeudoQuincenalChecked(enableAdeudoQuincenal);
        //setOtroChecked(!enableAdeudoQuincenal);

        let newInitialValues = { ...initialValues };
        //newInitialValues.productosAbonos = new Array(countItems).fill(0);
        newInitialValues.productosAbonos = new Array(newAllItems.length).fill(
          0,
        );

        setInitialValues(newInitialValues);

        updateProductoAbonos(newInitialValues.productosAbonos);

        setErrorProductosAmount(new Array(countItems).fill(""));

        setTotalAplicar(0);

        setInvalidEntrante(false);
      }

      updateCanSave();

      setIsActiveDisabled(!isActiveDisabled);

      //--

      console.log("--ll");
    }, [cobranzaItem, productoParcialidad, interestItem]);

    useEffect(() => {
      formik?.resetForm();

      const newPermissions = PermissionsForSection(Sections.Clientes);
      setPermissions(newPermissions);
    }, []);

    useEffect(() => {
      updateCanSave(usedAmount);
    }, [optionAbonarChecked, usedAmount, totalAplicar]);

    /*  let initialValues = {
      entrante: 0,
      productosAbonos: [],
    };*/

    const formik = useFormik({
      initialValues,
      enableReinitialize: true,
      validate: createMode ? createUserFormValidate : editUserFormValidate,
      validateOnBlur: false,
      validateOnChange: false,
    });

    useImperativeHandle(ref, () => ({
      getValue: () => {
        return formik.values;
      },
      toggleModal: () => {
        formik?.resetForm({
          entrante: 0,
          productosAbonos: [],
        });
        modalRef.current.click();

        /*      let initialValues = {
      entrante: 0,
      productosAbonos: [],
    };
*/

        //    updateProductoAbonos([]);
        formik.setValues({
          entrante: 0,
          productosAbonos: [],
        });
        setInitialValues({
          entrante: 0,
          productosAbonos: [],
        });

        //clear
        //const [canSave, setCanSave] = useState(false);

        //const [canAdeudoQuincenal, setCanAdeudoQuincenal] = useState(false);
        //const [adeudoQuincenalChecked, setAdeudoQuincenalChecked] = useState(false);
        setErrorOtroAmount("");

        //const [otroChecked, setOtroChecked] = useState(false);
      },
    }));

    useEffect(() => {
      console.log(
        `--> CHANGE formik .productosAbonos ${JSON.stringify(formik.values.productosAbonos)}`,
      );

      const newTotal = formik.values.productosAbonos.reduce(
        (acc, current, index) => {
          return acc + Number.parseFloat(current);
        },
        0,
      );
      setTotalAplicar(newTotal);
    }, [formik.values.productosAbonos]);

    /** manage address add/edit */
    function setupFields() {
      // fieldsSetup
      fieldsSetup.current = {};

      for (const [key, value] of Object.entries(initialValues)) {
        console.log(`${key}: ${value}`);

        const res = api.isFieldReadOnlyWith(createMode, value);
        fieldsSetup.current[key] = res;
      }
    }

    function testCanSave(entranteVal = null, totalPendiente = 0) {
      let canSave = false;
      if (OptionAbonar.AdeudoQuincenal === optionAbonarChecked) {
        canSave = (totalPendiente ?? 0) > 0;
      } else if (
        OptionAbonar.MismaCantidadCadaProducto === optionAbonarChecked
      ) {
        let num = 0;
        if (entranteVal) {
          num = Number.parseFloat(entranteVal);
        } else {
          num = Number.parseFloat(formik.values.entrante);
        }
        canSave = num > 0 && num <= cobranzaInfoDetail?.disponible;
      }
      return canSave;
    }

    function updateCanSave(entranteVal = null) {
      let canSave = false;

      if (pagoModalMode === PagoModalMode.Producto) {
        let totalPendiente = 0;
        if (productoParcialidad) {
          totalPendiente = parcialidadActual?.totalPendiente ?? 0;
        } else if (interestItem) {
          totalPendiente = interestItem?.totalPendiente ?? 0;
        }
        canSave = testCanSave(entranteVal, totalPendiente);
      } else if (pagoModalMode === PagoModalMode.Cliente) {
        /*
        - Seleccionado un check Otro
          > Otro  
            - debe ser mayor de 0
            - numero no debe ser mayor a lo que esta en Debe porductoparcialidades
            - la suma de cada fila no debe pasar a la cantidad disponible
         */
        if (
          OptionAbonar.MismaCantidadCadaProducto === optionAbonarChecked &&
          totalAplicar > 0
        ) {
          canSave = totalAplicar <= cobranzaInfoDetail?.disponible;
          if (totalAplicar > cobranzaInfoDetail?.disponible) {
            canSave = false;
          }
        } else if (OptionAbonar.AdeudoQuincenal === optionAbonarChecked) {
          canSave = adeudoQuincenal < cobranzaInfoDetail?.disponible;
        } else if (
          OptionAbonar.DiferenteCantidadCadaProducto === optionAbonarChecked
        ) {
          //formik.values.productosAbonos

          canSave = totalAplicar > 0;
        }
      }

      setCanSave(canSave);

      const showErrorAmount =
        usedAmount > cobranzaInfoDetail?.disponible
          ? "Cantidad se excede al saldo disponible"
          : "";
      setErrorOtroAmount(showErrorAmount);
    }

    function amountToSave() {
      let amount = 0;
      if (OptionAbonar.AdeudoQuincenal === optionAbonarChecked) {
        if (parcialidadActual != null) {
          amount = parcialidadActual.totalPendiente;
        } else if (interestItem == null) {
          amount = interestItem.totalPendiente;
        } else {
          console.log("--> INVALID parcialidadNumero");
          return;
        }
      } else if (
        OptionAbonar.MismaCantidadCadaProducto === optionAbonarChecked
      ) {
        amount = formik.values.entrante;
      }
      return amount;
    }

    function updateProductoAbonos(productosAbonos) {
      formik.setFieldValue("productosAbonos", productosAbonos);

      const newTotal = productosAbonos.reduce((acc, current, index) => {
        return acc + Number.parseFloat(current);
      }, 0);
      setTotalAplicar(newTotal);
    }

    function handleAmountChange(newValue, index, capValue = null) {
      let aValue = onlyNumbersFloat(newValue);
      if (capValue != null && Number.parseFloat(aValue) > capValue) {
        aValue = capValue;
      }

      let productosAbonos = formik.values.productosAbonos;
      productosAbonos[index] = aValue;

      updateProductoAbonos(productosAbonos);

      let value = Number.parseFloat(aValue);

      const showErrorAmount =
        value > cobranzaInfoDetail?.disponible
          ? "Cantidad se excede al disponible"
          : "";
      setErrorOtroAmount(showErrorAmount);

      let no = errorProductosAmount;
      let newError = "";

      no[index] = newError;
      setErrorOtroAmount(...no);

      updateCanSave(value);

      setInvalidEntrante(true);
    }

    const saldoDisponible = Singleton.getInstance().format(
      cobranzaInfoDetail?.disponible ?? 0,
    );

    const formatAdeudoQuincenal =
      Singleton.getInstance().format(adeudoQuincenal);

    /*const invalidEntranteClass = invalidEntrante
      ? `text-decoration-line-through thick-underline`
      : "";
      */
    const invalidEntranteClass = "";

    return (
      <>
        <button
          ref={modalRef}
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdropCrearAbono2"
          hidden
        >
          Abrir Crear Abono
        </button>
        <div
          className="modal fade modal-sms"
          id="staticBackdropCrearAbono2"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropCrearAbono2Label"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropCrearAbono2Label">
                  {createMode ? "Crear" : "Editar"} Abono
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => {
                    //if (returnBack != null) returnBack();
                  }}
                  disabled={isLoading}
                ></button>
              </div>

              <div className="modal-body">
                <form
                  className="row g-3"
                  onSubmit={(event) => {
                    event.preventDefault();
                    return false;
                  }}
                >
                  <div className="bd-example-row1">
                    <div className="row">
                      <ul className="list-group">
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          Saldo Disponble
                          <span className="badge text-bg-success rounded-pill fs-6">
                            {saldoDisponible}
                          </span>
                        </li>
                      </ul>

                      <div className="row">
                        <label
                          className="form-check-label"
                          style={{ marginTop: "20px", marginBottom: "10px" }}
                        >
                          Seleccione opcion a aplicar:
                        </label>
                      </div>

                      <ul className="list-group">
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <div className="form-check d-flex align-items-center">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="exampleRadios"
                              id="exampleRadios1"
                              value="option1"
                              checked={
                                optionAbonarChecked ===
                                OptionAbonar.AdeudoQuincenal
                              }
                              disabled={canAdeudoQuincenal}
                              onChange={(e) => {
                                //    setAdeudoQuincenalChecked(true);
                                //  setOtroChecked(false);

                                setOptionAbonarChecked(
                                  OptionAbonar.AdeudoQuincenal,
                                );
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="exampleRadios1"
                            >
                              Adeudo Quincenal {formatAdeudoQuincenal}
                            </label>
                          </div>
                        </li>

                        <li className="list-group-item d-flex flex-column justify-content-between align-items-center1 row-gap-2">
                          <div className="form-check d-flex align-items-center">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="exampleRadios"
                              id="exampleRadios2"
                              value="option2"
                              checked={
                                optionAbonarChecked ===
                                OptionAbonar.MismaCantidadCadaProducto
                              }
                              onChange={(e) => {
                                setOptionAbonarChecked(
                                  OptionAbonar.MismaCantidadCadaProducto,
                                );
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="exampleRadios2"
                            >
                              Abonar a todos misma cantidad:
                            </label>
                            <div
                              className={`input-group ${invalidClass(errorOtroAmount)}`}
                            >
                              <CurrencyInput
                                initialValue={formik.values.entrante}
                                value={formik.values.entrante}
                                className={`form-control ${invalidClass(errorOtroAmount)} ${invalidEntranteClass}`}
                                placeholder="Cantidad a Agregar"
                                onNewValueHandler={(aValue) => {
                                  //  console.log(p);

                                  setInvalidEntrante(false);

                                  if (aValue > cobranzaInfoDetail?.disponible) {
                                    formik.setFieldValue(
                                      "entrante",
                                      formik.values.entrante,
                                    );

                                    return;
                                  }
                                  formik.setFieldValue("entrante", aValue);

                                  let value = Number.parseFloat(aValue);

                                  //
                                  let productosAbonos = [
                                    ...formik.values.productosAbonos,
                                  ];
                                  let newUsedAmount = value;
                                  if (pagoModalMode === PagoModalMode.Cliente) {
                                    newUsedAmount = 0;
                                    //
                                    allItems.forEach((aItem, index) => {
                                      let totalPendiente =
                                        aItem?.totalPendiente;
                                      if (aItem?.type === "producto") {
                                        totalPendiente =
                                          aItem?.parcialidadActual
                                            .totalPendiente;
                                      }

                                      let newTotalPendiente = value;
                                      if (newTotalPendiente > totalPendiente) {
                                        newTotalPendiente = totalPendiente;
                                      }

                                      newUsedAmount += newTotalPendiente;

                                      productosAbonos[index] =
                                        newTotalPendiente;
                                    });

                                    updateProductoAbonos(productosAbonos);

                                    //formik.values.productosAbonos[index]
                                    // -
                                  }

                                  /*  if (isNaN(value)) {
                                    //  setNewTotal(newTotal);
                                      return;
                                    } */

                                  setUsedAmount(newUsedAmount);

                                  /* if (!otroChecked) {
                                    setOtroChecked(true);
                                    setAdeudoQuincenalChecked(false);
                                  }
                                    setOptionAbonarChecked(OptionAbonar.DiferenteCantidadCadaProducto)
                                    */
                                }}
                                disabled={false}
                              />
                              <span
                                className="input-group-text"
                                id="basic-addon2"
                              >
                                Cada Producto
                              </span>
                              {/*   <UpDown
                                upHandler={() => {}}
                                downHandler={() => {}}
                              /> */}
                            </div>
                            <div className="valid-feedback"></div>
                            <div className="invalid-feedback">
                              {errorOtroAmount}
                            </div>
                          </div>
                        </li>

                        <li className="list-group-item d-flex flex-column justify-content-between align-items-center1 row-gap-1">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="exampleRadios"
                              id="exampleRadios3"
                              value="option3"
                              checked={
                                optionAbonarChecked ===
                                OptionAbonar.DiferenteCantidadCadaProducto
                              }
                              onChange={(e) => {
                                setOptionAbonarChecked(
                                  OptionAbonar.DiferenteCantidadCadaProducto,
                                );
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="exampleRadios3"
                            >
                              Abono Individual:
                            </label>
                          </div>
                          {pagoModalMode === PagoModalMode.Cliente && (
                            <CreatePagoTable
                              totalAplicar={totalAplicar}
                              allItems={allItems}
                              errorProductosAmount={errorProductosAmount}
                              handleAmountChange={handleAmountChange}
                            />
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  ref={buttonCancelModalRef}
                  onClick={(e) => {
                    //  if (returnBack != null) returnBack();
                  }}
                  disabled={isLoading}
                >
                  Cancelar
                </button>
                <LoadingButton
                  style={{ height: "38px" }}
                  onClick={async (e) => {
                    formik.handleSubmit();
                    // Fetch all the forms we want to apply custom Bootstrap validation styles to

                    let extraInfo = {};
                    if (cobranzaItem.cliente) {
                      extraInfo = { clienteId: cobranzaItem.cliente.id };
                    }
                    /*else if (cobranzaItem.cliente == null) {
                      extraInfo = { clienteId: cobranzaItem.cliente.id };
                    }*/

                    //TEMP
                    //  const formaDePagoSelected = 1;
                    let response = null;
                    if (pagoModalMode === PagoModalMode.Producto) {
                      const porPagar = amountToSave();
                      if (parcialidadActual == null && interestItem == null) {
                        console.log("--> INVALID parcialidadNumero");
                        return;
                      }

                      setIsLoading(true);

                      response = await api
                        .createSubPago({
                          pagoId: asociadoId,
                          parcialidadId: parcialidadActual?.id,
                          interesParcialidadId: interestItem?.id,
                          Total: porPagar,
                          ...extraInfo,
                        })
                        .catch((e) => {
                          toast.error("Error al crear SubPago.");
                        });
                    } else if (pagoModalMode === PagoModalMode.Cliente) {
                      setIsLoading(true);

                      /*
    public int? InteresParcialidadId { get; set; }
        public int? ParcialidadId { get; set; }
        public decimal? Total { get; set; }
        */
                      let infos = [];
                      if (
                        OptionAbonar.AdeudoQuincenal === optionAbonarChecked
                      ) {
                        allItems.forEach((aItem, index) => {
                          let interesParcialidadId = null;
                          let parcialidadId = null;
                          let total = aItem?.parcialidadActual?.totalPendiente;

                          if (aItem.parcialidadActual != null) {
                            parcialidadId = aItem.parcialidadActual.id;
                          } else {
                            total = aItem?.totalPendiente;
                            interesParcialidadId = aItem.id;
                          }

                          infos.push({
                            interesParcialidadId: interesParcialidadId,
                            parcialidadId: parcialidadId,
                            total: total,
                          });
                        });
                      } else if (
                        OptionAbonar.MismaCantidadCadaProducto ===
                        optionAbonarChecked
                      ) {
                        allItems.forEach((aItem, index) => {
                          const productosAbonos = formik.values.productosAbonos;

                          let interesParcialidadId = null;
                          let parcialidadId = null;
                          let total = Number.parseFloat(productosAbonos[index]);

                          // no se ha modificado entonces ignorar
                          if (total === 0) {
                            return;
                          }

                          //  let totalPendiente =
                          //  aItem?.totalPendiente;
                          if (aItem.parcialidadActual != null) {
                            parcialidadId = aItem.parcialidadActual.id;
                          } else {
                            interesParcialidadId = aItem.id;
                          }

                          infos.push({
                            interesParcialidadId: interesParcialidadId,
                            parcialidadId: parcialidadId,
                            total: total,
                          });

                          /*  let newTotalPendiente = value;
                                      if (newTotalPendiente > totalPendiente) {
                                        newTotalPendiente = totalPendiente;
                                      }

                                      newUsedAmount += newTotalPendiente;

                                      productosAbonos[index] =
                                        newTotalPendiente;*/
                        });
                      }

                      response = await api
                        .clienteProrrateo({
                          asociadoId: asociadoId,
                          clienteId: extraInfo.clienteId,
                          info: infos,
                        })
                        .catch((e) => {
                          toast.error(
                            "Error al aplicar prorrateo a Cliente!" /*, {
                                id: toastId,
                              }*/,
                          );
                        });
                    }

                    setIsLoading(false);
                    if (!response) return;

                    setTimeout(() => {
                      reloadCobranza?.();

                      buttonCancelModalRef.current.click();
                    }, 500);

                    //-
                  }}
                  text={"Guardar"}
                  loadingText={"Guardando..."}
                  isLoading={isLoading}
                  isDisable={!canSave}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  },
);

export default CreatePago;
